import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import { IThankYouPage } from 'interfaces/IThankYouPage';
import CardDefault from './CardDefault/index';
import CardProducer from './CardProducer/index';
import { pixelService, enPixelPath } from 'services/PixelService';

interface IProps {
  infos: IThankYouPage;
}
export default class CardPage extends BaseComponent<{}, IProps>{

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    pixelService.track(enPixelPath.THANKYOU);
  }

  render() {
    return (
      <div>
        {this.props.infos.isDefault ?
          <CardDefault infos={this.props.infos} /> :
          <CardProducer infos={this.props.infos} />
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ThankYouPage/CardPage/index.tsx